/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Divider, Input, ModalBody, ModalFooter, ModalHeader, Select, SelectItem, Spinner, Tooltip } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { TeacherGroupService, SchoolService } from '../../../../services';
import { IconTrash, IconEdit } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { classNames } from '../../../../utils'

const ModalCreateSection = ({ item, onSuccess, onClose }) => {
  const { addSection, form, onChange, onSubmit, grades, removeSection, sections, isLoading, data } = useForm(item);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Secciones</ModalHeader>
      <ModalBody className="gap-8 p-0">
        {isLoading ?? (
          <div className="absolute w-full h-full inset-0 z-[70] flex justify-center items-center bg-white/30">
            <Spinner />
          </div>
        )}
        <div className="flex flex-col flex-1 gap-4 px-6">
          <div className='flex items-end justify-between'>
            <Select
              label="Crear sección"
              labelPlacement="outside"
              placeholder="Seleccione"
              variant="bordered"
              className='w-[20rem]'
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form._grade ? [form._grade] : []}
              onSelectionChange={v => onChange(v.currentKey, '_grade')}
            >
              {grades.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

            <Button
              className="bg-green text-white"
              onClick={addSection}
              isDisabled={!form._grade || !form._section}
            >
              Guardar
            </Button>
          </div>

          <div className='flex items-end gap-4'>
            <Input
              label=""
              labelPlacement="outside"
              className='w-[20rem]'
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form._section}
              onValueChange={v => onChange(v, '_section')}
            />

            <Button
              className='bg-primary text-white'
              onClick={addSection}
            //isDisabled={!form._grade || !form._section}
            >
              Añadir sección
            </Button>
          </div>


          <div className='mt-4'>
            <div className='flex gap-2'>
              {sections.map((section, idx) => (
                <p
                  key={idx}
                  className='bg-primary text-white p-2 rounded-lg text-sm cursor-pointer'
                  onClick={() => removeSection(idx)}
                >
                  {section}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className='bg-primary px-6 py-4 text-white'>

          <p className='font-bold'>Secciones registradas</p>

          <div className='grid grid-cols-3 gap-4 mt-1'>
            <p>Grado</p>
            <p>Secciones</p>
            <p className='flex justify-end'>Acciones</p>
          </div>
        </div>

        {
          data.map((item, idx) => (
            <div key={idx} className='grid grid-cols-3 border-b border-foreground-300 pb-4'>
              <p className='pl-6'>{item.grade}</p>
              <p>{item.sections.join(', ')}</p>
              <div className="relative flex justify-end items-center gap-2 pr-6">
                <Tooltip content="Editar">
                  <IconEdit />
                </Tooltip>
                <Tooltip content="Eliminar" color="danger">
                  <IconTrash className="text-danger" />
                </Tooltip>
              </div>
            </div>
          ))
        }




      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item) => {
  const initialForm = {
    _grade: '',
    _section: '',
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [sections, setSections] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [school_years, setSchoolYears] = useState([]);
  const [grades, setGrades] = useState([]);


  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const addSection = () => {
    setSections([...sections, form._section]);
    setForm(s => ({
      ...s,
      _section: '',
    }));
  }

  const removeSection = (index) => {
    setSections(sections.filter((_, idx) => index !== idx));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }


  const getData = async () => {
    setIsLoading(true);
    try {
      const gradesData = await TeacherGroupService.groups.getGrades({ professor_id: user.id });
      const schoolYears = await SchoolService.schoolAdmin.getSchoolarsYears();
      setSchoolYears(schoolYears);
      setGrades(gradesData);
      setIsLoading(false);
    } catch (error) {
      onError(String(error));
    } finally {
      setIsLoading(false);
    }
  }

  const isValidForm = () => {
    if (!sections.length)
      return onError('Debe indicar al menos una sección');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {

      toast.success('Grado creado correctamente');
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }


  useEffect(() => {
    getData()
  }, [])



  return {
    form,
    onChange,
    onSubmit,
    grades,
    sections,
    addSection,
    removeSection,
    isLoading,
    data
  }
}

export default ModalCreateSection;
